// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"30c48ed9","703":"600a5640"}[chunkId] + ".chunk.js";
};